<template>
  <span class="ajaxForm">{{lookup.value}}</span>
</template>

<script>
export default {
  name: "Lookup",
  props: ["lookup"]
};
</script>